import type { ApiClient } from '../client'
import type {
  PlatformBillingOverview,
  CreateResellerRequest,
  DeletedFilter,
  OnboardClientRequest,
  OnboardedClient,
  Organization,
  Reseller,
  UpdateResellerRequest,
} from '../types'

/** src/modules/tenancy/resellers/controllers/resellers.controller.ts */
export function resellersEndpoints(api: ApiClient) {
  return {
    list: () => api.get<readonly Reseller[]>('resellers'),
    get: (id: string) => api.get<Reseller>(`resellers/${id}`),
    create: (body: CreateResellerRequest) => api.post<Reseller>('resellers', body),
    update: (id: string, body: UpdateResellerRequest) =>
      api.patch<Reseller>(`resellers/${id}`, body),
    roster: (id: string) => api.get<readonly Organization[]>(`resellers/${id}/roster`),
    /** Creates the organisation AND its invited owner; the raw invite token comes back once. */
    onboard: (id: string, body: OnboardClientRequest) =>
      api.post<OnboardedClient>(`resellers/${id}/clients`, body),
    /** Detaches: `reseller_id` becomes null, the organisation and its data survive. */
    removeClient: (id: string, orgId: string) =>
      api.delete<Organization>(`resellers/${id}/clients/${orgId}`),
  }
}

/** The cross-org routes of organizations.controller.ts (platform / reseller plane). */
export function platformOrganizationsEndpoints(api: ApiClient) {
  return {
    list: (deleted: DeletedFilter = 'false') =>
      api.get<readonly Organization[]>('organizations', { query: { deleted } }),
    setPlan: (id: string, plan_tier: string) =>
      api.patch<Organization>(`organizations/${id}/plan`, { plan_tier }),
    /** Soft delete: the row keeps `deleted_at`; nothing is purged. */
    remove: (id: string) => api.delete<Organization>(`organizations/${id}`),
  }
}

/** src/modules/billing/controllers/platform-billing.controller.ts — `billing:overview`, platform admin only. */
export function platformBillingEndpoints(api: ApiClient) {
  return {
    overview: () => api.get<PlatformBillingOverview>('platform/billing-overview'),
  }
}
